// @ts-nocheck
import React from 'react';
import { Clock, CheckCircle, BarChart3, Trophy, Activity } from 'lucide-react';
import './ProgressTracker.css';

const ProgressTracker = ({
  processed,
  total,
  currentPeriod,
  completed = false,
  mappedAccounts,
  totalAccounts,
  mappingProgress,
  isOptimized = false,
  sections = [],
  netProfitCheck = null,
}) => {
  // For comparative flow with multiple sections
  if (sections.length > 0) {
    const currentSection = sections.find(s => s.status === 'active') || sections.find(s => s.status === 'pending') || sections[sections.length - 1];

    return (
      <div className={`progress-tracker multi-section border-beam-container ${completed ? 'completed' : 'active loading'}`}>
        <div className="border-beam"></div>
        <div className="progress-header">
          <div className="progress-icon">
            {completed ? <Trophy size={20} className="trophy" /> : <div className="coral-ring-loader"></div>}
          </div>
          <div className="progress-title">
            <h3>{completed ? 'Comparative Analysis Complete!' : `Processing: ${currentSection?.name || 'Initializing...'}`}</h3>
            <p>{completed ? 'All sheets processed successfully' : 'Processing Raw Data and Comparable Sheets sequentially'}</p>
          </div>
        </div>

        <div className="sections-list">
          {sections.map((section, index) => {
            const pct = section.total > 0 ? (section.processed / section.total) * 100 : 0;
            return (
              <div key={section.id || index} className={`section-item ${section.status}`}>
                <div className="section-info">
                  <span className="section-name">{section.name}</span>
                  <span className="section-stats">
                    {section.status === 'completed' ? <CheckCircle size={14} /> : null}
                    {section.processed} / {section.total}
                  </span>
                </div>
                <div className="progress-bar mini">
                  <div className="progress-fill" style={{ width: `${pct}%` }}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // Legacy single-bar mode
  const actualProcessed = isOptimized ? mappedAccounts || 0 : processed || 0;
  const actualTotal = isOptimized ? totalAccounts || 0 : total || 0;
  const progressPercentage = isOptimized && mappingProgress ? mappingProgress :
                           actualTotal > 0 ? (actualProcessed / actualTotal) * 100 : 0;

  const isAccountMapping = isOptimized && actualTotal > 0;

  return (
    <div className={`progress-tracker border-beam-container ${completed ? 'completed' : 'active loading'}`}>
      <div className="border-beam"></div>
      <div className="progress-header">
        <div className="progress-icon">
          {completed ? (
            <Trophy size={20} className="trophy" />
          ) : (
            <div className="coral-ring-loader"></div>
          )}
        </div>
        <div className="progress-title">
          <h3>
            {completed ?
              'Optimized Processing Complete!' :
              isAccountMapping ?
                'Mapping Unique Accounts' :
                'Processing Multiple Periods'
            }
          </h3>
          <p>
            {completed ?
              'Successfully mapped accounts across all selected financial periods' :
              isAccountMapping ?
                'Using AI to categorize each unique account name once, then applying to all periods' :
                'Mapping accounts across all selected financial periods'
            }
          </p>
        </div>
      </div>

      <div className="progress-details">
        <div className="progress-stats">
          <div className="stat-item">
            <CheckCircle size={16} />
            <span>
              {completed ?
                (isAccountMapping ? 'All Accounts:' : 'All Periods:') :
                'Completed:'
              } {actualProcessed}/{actualTotal}
            </span>
          </div>
          <div className="stat-item">
            <Clock size={16} />
            <span>{completed ? 'Status:' : 'Current:'} {currentPeriod || 'Starting...'}</span>
          </div>
          <div className="stat-item">
            <BarChart3 size={16} />
            <span>{completed ? '100% Complete' : `${progressPercentage.toFixed(1)}% Complete`}</span>
          </div>
        </div>

        <div className="progress-bar-container">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          <div className="progress-text">
            {isAccountMapping ?
              `${actualProcessed} of ${actualTotal} unique accounts mapped` :
              `${actualProcessed} of ${actualTotal} periods processed`
            }
          </div>
        </div>

        {!isAccountMapping && actualTotal > 0 && actualTotal <= 10 && (
          <div className="period-indicators">
            {Array.from({ length: actualTotal }, (_, index) => (
              <div
                key={index}
                className={`period-indicator ${
                  index < actualProcessed
                    ? 'completed'
                    : index === actualProcessed
                      ? 'current'
                      : 'pending'
                }`}
                title={`Period ${index + 1}`}
              >
                {index < actualProcessed ? (
                  <CheckCircle size={12} />
                ) : index === actualProcessed ? (
                  <Activity size={12} className="spinning" />
                ) : (
                  <div className="pending-dot"></div>
                )}
              </div>
            ))}
          </div>
        )}

        {currentPeriod && !netProfitCheck && (
          <div className="current-period-info">
            <div className={`current-period-badge ${isAccountMapping ? 'account-mapping' : ''}`}>
              {isAccountMapping ? currentPeriod : `Processing: ${currentPeriod}`}
            </div>
          </div>
        )}
      </div>

      {/* Checking spinner only — full summary now lives in NetProfitBreakdown */}
      {netProfitCheck?.phase === 'checking' && (
        <div className="net-profit-summary-row">
          <div className="coral-ring-loader small"></div>
          <span>Checking net profit balance…</span>
        </div>
      )}
    </div>
  );
};

export default ProgressTracker;
